<template>
  <div class="tabs">
    <div class="tab">字幕设置</div>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.tabs {
  border-bottom: 2px solid #D4D4E7;
}
.tab {
  width:113px;
  padding-top: 9px;
  padding-bottom: 9px;
  border-bottom: 2px solid #5778FB;
  text-align: center;
  transform: translateY(2.2px);
  font-size:14px;
  color:#474261;
}
</style>



// WEBPACK FOOTER //
// src/components/subtitle/subtitlePanel/tabs.vue